/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was manually created for TanStack Router.
// In a proper setup, the @tanstack/router-plugin would generate this.

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as ShortIdIndexImport } from './routes/$shortId/index'
import { Route as ShortIdRevisionImport } from './routes/$shortId/$revision'

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
})

const ShortIdIndexRoute = ShortIdIndexImport.update({
  id: '/$shortId/',
  path: '/$shortId/',
  getParentRoute: () => rootRoute,
})

const ShortIdRevisionRoute = ShortIdRevisionImport.update({
  id: '/$shortId/$revision',
  path: '/$shortId/$revision',
  getParentRoute: () => rootRoute,
})

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$shortId/': {
      id: '/$shortId/'
      path: '/$shortId/'
      fullPath: '/$shortId/'
      preLoaderRoute: typeof ShortIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/$shortId/$revision': {
      id: '/$shortId/$revision'
      path: '/$shortId/$revision'
      fullPath: '/$shortId/$revision'
      preLoaderRoute: typeof ShortIdRevisionImport
      parentRoute: typeof rootRoute
    }
  }
}

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  ShortIdIndexRoute,
  ShortIdRevisionRoute,
})
